'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export default class CenterInputField extends React.Component {
  static propTypes = {
    defaultValue: PropTypes.string.isRequired,
    updater: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue,
    };
  }

  componentDidMount() {
    this.props.updater.addListener('Center.set', this.listener);
  }

  componentWillUnmount() {
    this.props.updater.removeListener('Center.set');
  }

  listener = (center) => {
    this.setState({ value: this.formatCenter(center) });
  }

  formatCenter(center) {
    return `POINT(${center.lat} ${center.lng})`;
  }

  render() {
    return (
      <input
        type="hidden"
        value={this.state.value}
        name="event[center]"
        id="event_center" />
    );
  }
}
